import DOMPurify from 'dompurify';

/**
 * Sanitize HTML before rendering with dangerouslySetInnerHTML.
 *
 * Strips <script>, on* event handlers, javascript: URLs, dangerous tags,
 * and other common XSS vectors. Use for any HTML that originates from
 * admin-editable content (legal docs, blog posts, etc.).
 */
export const sanitizeHtml = (dirty: string): string => {
  if (!dirty) return '';
  return DOMPurify.sanitize(dirty, {
    USE_PROFILES: { html: true },
    FORBID_TAGS: ['style', 'iframe', 'object', 'embed', 'form'],
    FORBID_ATTR: ['style', 'onerror', 'onload', 'onclick'],
  });
};
